import {Utils} from '@ideals/utils';
import {IItem, ISimplePayload} from '../interfaces';

export class ItemSimplePayload implements IItem<ISimplePayload> {
  /**
   * @deprecated Use "id" instead
   */
  // 'Id' with type any because of 'Id' can be number or string
  public set Id(value: any) {
    this.id = value;
  }

  /**
   * @deprecated Use "id" instead
   */
  public get Id(): any {
    return this.id;
  }

  /**
   * @deprecated Use "caption" instead
   */
  public set Name(value: string) {
    this._caption = value;
  }

  /**
   * @deprecated Use "caption" instead
   */
  public get Name(): string {
    return this._caption;
  }

  /**
   * @deprecated Use "caption" instead
   */
  public set name(value: string) {
    this._caption = value;
  }

  /**
   * @deprecated Use "caption" instead
   */
  public get name(): string {
    return this._caption;
  }

  public set caption(value: string) {
    this._caption = value;
  }

  public get caption(): string {
    return this._caption;
  }

  public payload: ISimplePayload;

  // 'id' with type any because of 'id' can be number or string
  public id: any;

  private _caption: string;

  public static isPrototypeOf(value: any): boolean {
    return value instanceof ItemSimplePayload;
  }

  constructor(item: IItem<ISimplePayload>) {
    this.id = Utils.isDefined(item.id) ? item.id : item.Id;
    this.caption = item.caption || item.Name || item.name;
    this.payload = item.payload || {};
  }
}
